<template>
  <div class="container">
    <div>快递公司：{{deliveryName}}</div>
    <div>快递单号：{{deliveryNum}}</div>
    <van-steps direction="vertical" :active="LoadData.length - 1" v-if="LoadData.length !== 0">
      <van-step v-for="(item, index) in LoadData" :key="index">
        <div>{{ item.remark }}</div>
        <div>{{ item.datetime }}</div>
      </van-step>
    </van-steps>
    <van-empty description="暂无物流信息" vv-else/>
  </div>
</template>

<script>
export default {
  name: "logistics",
  data() {
    return {
      LoadData: [],
      deliveryName:'',
      deliveryNum:''
    };
  },
  created() {
    const id = this.$route.query.id;
    this.deliveryName = this.$route.query.deliveryName
    this.deliveryNum = this.$route.query.deliveryNum
    this.getLogistics(id);
  },
  methods: {
    async getLogistics(id) {
      const { data } = await this.$http.request(
        this.$http.pathMap.logistics + "/" + id,
        "get"
      );
      this.LoadData = data;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 10px;
}
</style>
